/**
 * 작업 지시서 관련 상수 정의
 *
 * [중앙화 원칙] 사용자에게 보이는 문구는 이 파일에 두지 않는다 — i18n(messages.json)이 단일 원천이다.
 * 아래 상수들이 라벨을 함께 들고 있던 탓에 국가코드·시술유형·성별이 enums/common.js, dent.js와
 * 이중 정의되어 한쪽만 고치면 조용히 어긋나는 구조였다. 사용처 0건임을 실측하고 전부 제거했다(2026-08-13).
 *
 * 제거된 것과 실제 원천:
 *   PROGRESS_TEXTS      → index.vue progressTexts (i18n workorder_stepN_title)
 *   SURGERY_TYPES/_LABELS → components/enums/dent.js
 *   GENDER_MAP          → GenderSelect.vue (i18n workorder_gender_*)
 *   COUNTRY_CODES       → components/enums/common.js countryCodes
 *                         (셀렉트 노출분은 primaryCountryCodeValues, 조립은 build*CountryCodeList)
 *   SEND_CHANNELS       → components/enums/common.js sendChannel + Step2 SUPPORT_MSG_CHANNEL
 *   LANGUAGES           → components/enums/common.js language
 *   DENTALMAX_PRODUCTS  → china-inapi 제품 조회 API
 *   API_ENDPOINTS       → apis/workOrder.js
 */

// 단계 정보 — index.vue가 단계 수(steps.length) 판정에만 사용한다.
// 화면에 나가는 단계명은 i18n workorder_step1~4_title이 담당하므로 여기엔 라벨을 두지 않는다.
export const STEPS = [
  { id: 0 },
  { id: 1 },
  { id: 2 },
  { id: 3 }
];
